import { useState } from "react";
import { useAppDispatch } from "../utils";
import { citizenApi } from "../api/citizenApi";
import { downloadFileFromUrl } from "../utils/download";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";

export const useCollectionYardVisitReceipt = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { t } = useTranslation();

  const downloadReceipt = async (visitId: number, visitDate: string) => {
    setLoading(true);
    setError(null);

    try {
      const response = await dispatch(
        citizenApi.endpoints.getCollectionYardVisitReceiptUrl.initiate(visitId)
      ).unwrap();

      const formattedVisitDate = new Date(visitDate).toISOString().split("T")[0];

      const fileName = `${t("receipt")} ${formattedVisitDate}.pdf`;
      downloadFileFromUrl(response.fileUrl, fileName, response.base64);
      enqueueSnackbar(t("receiptDownloadSuccess"), { variant: "success" });
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      setError(message || "Failed to download receipt");
      enqueueSnackbar(t("errors.receiptExportError"), { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return { downloadReceipt, loading, error } as const;
};
